import { render, staticRenderFns } from "./look.vue?vue&type=template&id=14badd6d&"
import script from "./look.vue?vue&type=script&lang=js&"
export * from "./look.vue?vue&type=script&lang=js&"
import style0 from "./look.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports